module.exports = __webpack_public_path__ + "c_static/img/ios-share.3a463b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/ios-share.png
// module id = 82Dc
// module chunks = 33